/**
 *  @class
 *  @function LocalizationForm
 */
function _debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;

      // The element can be created before its children are parsed.
      // Wait for the inner form instead of assuming it already exists.
      if (this.querySelector('form') || document.readyState !== 'loading') {
        this.init();
      } else {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      }
    }

    init() {
      if (this._initialized) return;
      this._initialized = true;

      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = _debounce(() => this.onSubmitHandler(), 200);
      this.inputs.forEach((item) => item.addEventListener('change', this.debouncedOnSubmit));
    }

    onSubmitHandler() {
      this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}